import { render, staticRenderFns } from "./create-strategy.vue?vue&type=template&id=44612312&scoped=true&"
import script from "./create-strategy.vue?vue&type=script&lang=js&"
export * from "./create-strategy.vue?vue&type=script&lang=js&"
import style0 from "./create-strategy.vue?vue&type=style&index=0&id=44612312&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44612312",
  null
  
)

export default component.exports